export const fetchBenchmarkTaxonomyStart = (state, payload) => {
    return {
        ...state,
        fetchBenchmarkTaxonomyApi: {
            ...state.fetchBenchmarkTaxonomyApi,
            isProcessing: true,
            error: false,
            data: null
        },
        sampleCommentsFilters: {
            categoryKey: '',
            subKey: '',
            behaviorKey: 'all',
        },

    };
};

export const fetchBenchmarkTaxonomySuccess = (state, payload) => {
    return {
        ...state,
        fetchBenchmarkTaxonomyApi: {
            ...state.fetchBenchmarkTaxonomyApi,
            isProcessing: false,
            error: false,
            data: payload.data && payload.data.data ? payload.data.data : null
        }

    };
};

export const fetchBenchmarkTaxonomyFail = (state, payload) => {
    return {
        ...state,
        fetchBenchmarkTaxonomyApi: {
            ...state.fetchBenchmarkTaxonomyApi,
            isProcessing: false,
            error: true,
            data: null
        }

    };
};
